import { Component, Input } from '@angular/core';
import { AppState } from '../../config/state';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Platform, Events, NavParams, ViewController } from 'ionic-angular';
import { AppScreen } from '../../providers/config/config';

/**
 * Generated class for the CoIframeComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-iframe',
  templateUrl: 'co-iframe.html',
})
export class CoIframeComponent {
  source: SafeResourceUrl;
  siteLink: string;
  classString: string;
  showPage: boolean = false;
  frameSideAnimation: string;
  constructor(private state: AppState, private sanitizer: DomSanitizer, public platform: Platform, private events: Events, private navParams: NavParams, private viewCtrl: ViewController) {
    // console.log(this.navParams);
    this.siteLink = this.navParams.data.block.settings.link;
    this.classString = this.navParams.data.classString;
    this.santizeLink(this.siteLink);
  }

  santizeLink(info) {
    this.source = this.sanitizer.bypassSecurityTrustResourceUrl(info);
  }

  ionViewDidEnter() {
    let animationIn;
    this.state.currentScreen.menuSide === 'left'? animationIn = 'slideInLeft' : animationIn = 'slideInRight';
    setTimeout(() => {
      let popover = document.getElementsByClassName(this.navParams.data.opts.cssClass).item(0);
      popover.classList.remove(animationIn);
      // popover.getElementsByClassName('popover-content').item(0).classList.add(this.frameSideAnimation);
    }, 0);
  }

  ionViewWillLeave() {
    this.state.currentScreen.menuSide === 'left'? this.frameSideAnimation = 'slideOutLeft' : this.frameSideAnimation = 'slideOutRight';
    setTimeout(() => {
      let popover = document.getElementsByClassName(this.classString).item(0);
      popover.classList.add(this.frameSideAnimation);
      // popover.getElementsByClassName('popover-content').item(0).classList.add(this.frameSideAnimation);
    }, 0)
  }

}



// WEBPACK FOOTER //
// ./src/components/co-iframe/co-iframe.ts